import { useCallback, useEffect, useState } from 'react';

// TODO: Check if is it really needed to add further checks on fullscreen
// This was implemented for the showcase app but is actually not used
// and it doesn't work properly on mobile devices

// const FULLSCREEN_DETECT_DIFFERENTIAL_TOLLERANCE = 50;

export const useFullScreenStatus = () => {
  const [isFullScreen, setIsFullScreen] = useState<boolean>(
    document.fullscreenElement != null,
    // ||
    //   (Math.abs(
    //     window.screen.height -
    //       FULLSCREEN_DETECT_DIFFERENTIAL_TOLLERANCE -
    //       window.innerHeight,
    //   ) <= FULLSCREEN_DETECT_DIFFERENTIAL_TOLLERANCE &&
    //     Math.abs(window.screen.availHeight - window.innerHeight) <=
    //       FULLSCREEN_DETECT_DIFFERENTIAL_TOLLERANCE),
  );

  const updateFullscreenStatus = useCallback(() => {
    setIsFullScreen(
      document.fullscreenElement != null,
      // ||
      //   Math.abs(
      //     window.screen.height -
      //       FULLSCREEN_DETECT_DIFFERENTIAL_TOLLERANCE -
      //       window.innerHeight,
      //   ) <= FULLSCREEN_DETECT_DIFFERENTIAL_TOLLERANCE ||
      //   Math.abs(window.screen.availHeight - window.innerHeight) <=
      //     FULLSCREEN_DETECT_DIFFERENTIAL_TOLLERANCE,
    );
  }, [setIsFullScreen]);

  useEffect(() => {
    document.addEventListener('fullscreenchange', updateFullscreenStatus);
    // window.addEventListener('resize', updateFullscreenStatus);
    return () => {
      document.removeEventListener('fullscreenchange', updateFullscreenStatus);
      // window.removeEventListener('resize', updateFullscreenStatus);
    };
  }, [updateFullscreenStatus]);

  return {
    isFullScreen,
  };
};
